module.exports = __webpack_public_path__ + "static/media/chart_empty-en.82a00ced.png";